// Minute Bundle Scheduled Reports
export const SCHEDULED_BUNDLES = 'SCHEDULED_BUNDLES'
export const SCHEDULED_BUNDLE = 'SCHEDULED_BUNDLE'
export const SCHEDULED_BUNDLE_CREATE = 'SCHEDULED_BUNDLE_CREATE'
export const SCHEDULED_BUNDLE_REMOVE = 'SCHEDULED_BUNDLE_REMOVE'
export const SCHEDULED_BUNDLE_BULK_REMOVE = 'SCHEDULED_BUNDLE_BULK_REMOVE'
export const SCHEDULED_BUNDLE_UPDATE = 'SCHEDULED_BUNDLE_UPDATE'

export default {
    SCHEDULED_BUNDLES,
    SCHEDULED_BUNDLE,
    SCHEDULED_BUNDLE_CREATE,
    SCHEDULED_BUNDLE_REMOVE,
    SCHEDULED_BUNDLE_BULK_REMOVE,
    SCHEDULED_BUNDLE_UPDATE,
}
